import { EntityType } from '../../../@types/entityTypes';
import { createBackgroundJob } from '../../../utils/BackgroundJobs';
import AssemblyPickingInstructionGenerateMutation from '../../../graphql/mutations/product/AssemblyPickingInstructionGenerateMutation.graphql';
import { onDocumentPrintComplete } from '../../../utils/DocumentUtils';
import { ReportType } from '../../schema/p4types';
import { customerDocument } from '../../../utils/mailMergeFields';

const generate = (state: any, props: any, variables: any, returnUrl: string | undefined | null) => {
  createBackgroundJob(
    AssemblyPickingInstructionGenerateMutation,
    {
      assemblyId: props.values.id,
      ...variables,
    },
    props,
    returnUrl,
    'Generate Picking Instruction',
    (job) => onDocumentPrintComplete(state, props, job)
  );
};

const AssemblyPickingInstruction: Partial<EntityType> = {
  title: 'Assembly Picking Instructions',
  type: 'AssemblyPickingInstruction',
  printFunctions: {
    generate,
  },
  configuration: {
    title: 'Assembly Picking Instruction',
    reportType: ReportType.AssemblyPickingList,
  },
  mergeFields: [
    ...customerDocument,
    {
      key: 'salesOrderNumber',
      text: 'Sales Order Number',
    },
  ],
};

export default AssemblyPickingInstruction;
